import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { PROGERE_LEGAL } from "../config/progereLegal";
import { PROGERE_MODULE } from "../config/progereModule";
import { useAuth } from "../context/AuthContext";
import { ProgereDownloadAppButton } from "./ProgereDownloadAppButton";

const LINKS = [
  { to: "/confidentialite", label: "Confidentialité (Loi 25)" },
  { to: "/conditions", label: "Conditions" },
  { to: "/temoins", label: "Témoins" },
  { to: "/accessibilite", label: "Accessibilité" },
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/securite-plateforme", label: "Sécurité" },
  { to: "/demande-confidentialite", label: "Demande de confidentialité" },
];

export function ProgereLegalFooter() {
  const { user } = useAuth();
  const authed = Boolean(user);
  const year = new Date().getFullYear();
  return (
    <footer className="progere-legal-footer" aria-label="Informations légales PROGÈRE" data-testid="progere-legal-footer">
      <div className="progere-legal-footer__inner">
        <div className="progere-legal-footer__identity">
          <div className="progere-legal-footer__brand">
            <Building2 aria-hidden="true" className="progere-legal-footer__icon" />
            <span>PROGÈRE — écosystème PROGÈRE {PROGERE_MODULE.name}</span>
          </div>
          <div className="progere-legal-footer__operator">
            Propulsé par <strong>{PROGERE_LEGAL.displayOperatorName}</strong>
          </div>
          <div className="progere-legal-footer__copyright">
            © {year} PROGÈRE — progere.ca. Tous droits réservés.
          </div>
          <div className="progere-legal-footer__download">
            <ProgereDownloadAppButton variant="footer" size="sm" moduleCode="punch" showSubtitle={false} />
          </div>
        </div>
        <nav className="progere-legal-footer__links" aria-label="Navigation juridique">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.slice(1)}`}>{l.label}</Link>
          ))}
          {authed ? (
            <Link to="/tableau" className="progere-legal-footer__login" data-testid="footer-account">Mon compte</Link>
          ) : (
            <Link to="/login" className="progere-legal-footer__login" data-testid="footer-login">Se connecter</Link>
          )}
        </nav>
      </div>
    </footer>
  );
}
